<form [formGroup]="parentForm">
  <div class="container">
    @for (filter of filters.controls; track filter; let filterIndex = $index) {
      <mat-card appearance="outlined" class="filter">
        <div class="container filter-form">
          <mat-form-field class="hint">
            <input matInput placeholder="Label" autocomplete="off" [formControl]="filter.get('label')" required />
            <mat-hint>The label used when selecting the filter</mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="ID"
              autocomplete="off"
              [formControl]="filter.get('value').get('id')"
              required
            />
            <mat-hint>
              The id that the value extracted from the value path will be saved under on the Loop Post
            </mat-hint>
          </mat-form-field>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Value Path"
              autocomplete="off"
              [formControl]="filter.get('value').get('valuePath')"
              required
            />
            <mat-hint>
              The path to the value on the event for this Loop Post Type that the filter should compare against
            </mat-hint>
          </mat-form-field>
          <div class="container">
            @for (option of getOptionsForFilter($index).controls; track option; let optionIndex = $index) {
              <mat-card appearance="outlined" class="filter">
                <div class="container filter-form">
                  <mat-form-field class="hint">
                    <input matInput placeholder="Label" autocomplete="off" [formControl]="option.get('id')" required />
                    <mat-hint>The label for the option</mat-hint>
                  </mat-form-field>
                  <mat-form-field class="hint">
                    <input
                      matInput
                      placeholder="Value"
                      autocomplete="off"
                      [formControl]="option.get('value')"
                      required
                    />
                    <mat-hint>
                      The value for the option that will be compared against the extracted value on the Loop Posts
                    </mat-hint>
                  </mat-form-field>
                </div>
                <button mat-icon-button>
                  <mat-icon
                    aria-label="Remove"
                    (click)="removeOption($event, filterIndex, optionIndex)"
                    matTooltip="Remove"
                  >
                    clear
                  </mat-icon>
                </button>
              </mat-card>
            }
            <button class="add" mat-button (click)="addOption($event, filterIndex)">+ Add Option</button>
          </div>
        </div>
        <button mat-icon-button>
          <mat-icon aria-label="Remove" (click)="removeFilter($event, filterIndex)" matTooltip="Remove">clear</mat-icon>
        </button>
      </mat-card>
    }
    <button class="add" mat-button (click)="addFilter($event)">+ Add Filter</button>
  </div>
</form>
